import React from 'react';

export const LogoutConfirmation = () => {
  return (
    <svg width="74" height="73" viewBox="0 0 74 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M49.2136 15.061L7.43945 15.0023V0.355469L49.2136 0.452403V15.061Z" fill="#F3F1EB" />
      <path
        d="M68.6524 40.5385C68.6524 43.1573 66.2322 45.2864 63.2575 45.2864H52.7233C51.9565 33.5033 51.8115 21.6055 51.8484 12.9566H63.2575C66.2322 12.9566 68.6524 15.0857 68.6524 17.7046V40.5385ZM5.07618 64.4209C7.73547 42.517 7.50018 1.13022 7.50018 1.13022H49.0873C49.0873 1.13022 49.053 43.2211 51.7848 64.4209H5.07618ZM63.2575 8.02503H51.8891C51.9527 3.06153 52.0582 0 52.0582 0H4.52931C4.52931 0 6.16863 47.1259 0.431641 72.3324H56.1559C54.7111 65.9836 53.7344 58.2443 53.082 50.218H63.2575C68.9436 50.218 73.5691 45.8757 73.5691 40.5385V17.7046C73.5691 12.3673 68.9436 8.02503 63.2575 8.02503Z"
        fill="#C2C2C2"
      />
      <path
        d="M44.3001 15.0512L31.6841 15.0333C31.6752 8.44723 31.6929 3.30514 31.7031 1.12891H44.281C44.2594 3.29621 44.225 8.41662 44.3001 15.0512Z"
        fill="#FFFDF7"
      />
      <path
        d="M49.2162 72.3324H33.6229C33.2121 71.3872 32.8878 68.5119 32.6296 64.4209H47.4599C47.9635 67.4365 48.5447 70.1205 49.2162 72.3324ZM44.283 1.13022H31.7051C31.7089 0.396725 31.7114 0 31.7114 0H44.2957C44.2957 0 44.2906 0.396725 44.283 1.13022Z"
        fill="#D4D4D4"
      />
      <path
        d="M27.3288 15.027L7.43945 14.9989C7.53229 6.77488 7.5005 1.12891 7.5005 1.12891H27.3288V15.027Z"
        fill="#F4F4F4"
      />
      <path
        d="M27.3285 72.3324H0.431641C6.42044 48.0609 4.53185 0.0535767 4.52931 0H27.3285V1.13022H7.50018C7.50018 1.13022 7.53197 6.77619 7.43913 15.0002C7.27889 29.0144 6.75493 50.5178 5.08635 64.3355C5.08635 64.338 5.08507 64.3431 5.08507 64.3456C5.0838 64.3559 5.08254 64.3648 5.08127 64.375C5.08127 64.3776 5.08126 64.3801 5.07999 64.3827C5.07872 64.3942 5.07746 64.4082 5.07618 64.4209H27.3285V72.3324Z"
        fill="#AEAFAF"
      />
      <path
        d="M52.127 8.63285C52.127 8.63285 65.1868 8.61625 66.6036 9.31785C71.6055 11.5094 72.6128 16.441 72.6128 16.441C72.6128 16.441 73.2105 19.884 72.5276 41.3057C72.5276 41.3057 72.4258 17.931 71.5546 16.2356C70.2383 11.9699 68.379 11.1331 66.1254 10.1228C63.8718 9.11248 52.127 8.63285 52.127 8.63285Z"
        fill="#E6E6E6"
      />
      <path d="M53.2269 49.5234L52.8848 47.8115L64.0853 49.1127L53.2269 49.5234Z" fill="#999999" />
      <path d="M68.9238 16.9883V41.3045L69.7428 40.9613L68.9238 16.9883Z" fill="#999999" />
      <path d="M51.791 12.0545V11.0264L64.084 12.2599L51.791 12.0545Z" fill="#999999" />
      <path d="M52.4316 64.7406H7.43164V0L49.4316 0.428459L52.4316 64.7406Z" fill="#F3F1EB" />
      <path
        d="M68.6524 40.5385C68.6524 43.1573 66.2322 45.2864 63.2575 45.2864H52.7233C51.9565 33.5033 51.8115 21.6055 51.8484 12.9566H63.2575C66.2322 12.9566 68.6524 15.0857 68.6524 17.7046V40.5385ZM5.07618 64.4209C7.73547 42.517 7.50018 1.13022 7.50018 1.13022H49.0873C49.0873 1.13022 49.053 43.2211 51.7848 64.4209H5.07618ZM63.2575 8.02503H51.8891C51.9527 3.06153 52.0582 0 52.0582 0H4.52931C4.52931 0 6.16863 47.1259 0.431641 72.3324H56.1559C54.7111 65.9836 53.7344 58.2443 53.082 50.218H63.2575C68.9436 50.218 73.5691 45.8757 73.5691 40.5385V17.7046C73.5691 12.3673 68.9436 8.02503 63.2575 8.02503Z"
        fill="#C2C2C2"
      />
      <path
        d="M44.3001 64.5L31.6841 64.4821C31.6752 57.896 31.6928 3.30514 31.703 1.12891H44.2809C44.2593 3.29621 44.225 57.8654 44.3001 64.5Z"
        fill="#FFFDF7"
      />
      <path
        d="M49.2162 72.3324H33.6229C33.2121 71.3872 32.8878 68.5119 32.6296 64.4209H47.4599C47.9635 67.4365 48.5447 70.1205 49.2162 72.3324ZM44.283 1.13022H31.7051C31.7089 0.396725 31.7114 0 31.7114 0H44.2957C44.2957 0 44.2906 0.396725 44.283 1.13022Z"
        fill="#D4D4D4"
      />
      <path d="M27.4308 65H4.93164C5.025 31.8626 7.49219 1 7.49219 1H27.4308V65Z" fill="#F4F4F4" />
      <path
        d="M27.3285 72.3324H0.431641C6.42044 48.0609 4.53185 0.0535767 4.52931 0H27.3285V1.13022H7.50018C7.50018 1.13022 7.53197 6.77619 7.43913 15.0002C7.27889 29.0144 6.75493 50.5178 5.08635 64.3355C5.08635 64.338 5.08507 64.3431 5.08507 64.3456C5.0838 64.3559 5.08254 64.3648 5.08127 64.375C5.08127 64.3776 5.08126 64.3801 5.07999 64.3827C5.07872 64.3942 5.07746 64.4082 5.07618 64.4209H27.3285V72.3324Z"
        fill="#AEAFAF"
      />
      <path
        d="M52.127 8.63285C52.127 8.63285 65.1868 8.61625 66.6036 9.31785C71.6055 11.5094 72.6128 16.441 72.6128 16.441C72.6128 16.441 73.2105 19.884 72.5276 41.3057C72.5276 41.3057 72.4258 17.931 71.5546 16.2356C70.2383 11.9699 68.379 11.1331 66.1254 10.1228C63.8718 9.11248 52.127 8.63285 52.127 8.63285Z"
        fill="#E6E6E6"
      />
      <path d="M53.2269 49.5234L52.8848 47.8115L64.0853 49.1127L53.2269 49.5234Z" fill="#999999" />
      <path d="M68.9238 16.9883V41.3045L69.7428 40.9613L68.9238 16.9883Z" fill="#999999" />
      <path d="M51.791 12.0545V11.0264L64.084 12.2599L51.791 12.0545Z" fill="#999999" />
      <path
        d="M48.828 58.3902C48.828 58.3902 53.3947 51.1401 46.7053 48.1183C33.8458 47.5634 37.8425 49.1161 32.1954 49.5627C28.6315 49.8442 25.6819 50.8183 22.8432 50.7623C15.0681 50.6072 12.4563 49.9929 7.98971 51.962C3.56652 54.6807 7.2098 58.3902 7.2098 58.3902H48.828Z"
        fill="#F8F8F8"
      />
      <path
        d="M6.03164 56C6.03164 58.0571 4.96497 62.8571 4.43164 65H52.4316L50.8316 56C50.8316 56 42.8316 53.7501 28.4316 56C14.0316 58.2498 6.03164 56 6.03164 56Z"
        fill="url(#paint0_linear_17291_4966)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_17291_4966"
          x1="52.5495"
          y1="60.275"
          x2="4.13939"
          y2="60.275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset="1" stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
};
